import React, { useEffect, useState } from 'react';
import styles from "./paymentpage.module.css"
import HomePageHeader from "./../../components/HomePageHeader";
import HomePageFooter from "./../../components/HomePageFooter";
import place_marker from "./../../assets/place_marker_icon.png"
import { useLocation, useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { updateOrderPayment } from '../../apis/payment';
import ImageWithFallback from '../../components/ImageWithFallback';

const PaymentPage = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [cookie, setCookie] = useCookies(["access_token"])

  const params = new URLSearchParams(location.search);

  const [paymentStatus, setPaymentStatus] = useState({
    amount: "",
    bankCode: "",
    bankTranNo: "",
    cardType: "",
    orderInfo: "",
    payDate: "",
    responseCode: "",
    tmnCode: "",
    transactionNo: "",
    transactionStatus: "",
    bhiveTransactionNo: "",
    secureHash: "",
  });

  useEffect(() => {
    console.log(params.get('vnp_Amount')) //required
    console.log(params.get('vnp_BankCode')) //required
    console.log(params.get('vnp_BankTranNo')) //optional
    console.log(params.get('vnp_CardType')) //optional
    console.log(params.get('vnp_OrderInfo')) //required
    console.log(params.get('vnp_PayDate')) //optional
    console.log(params.get('vnp_ResponseCode')) //required
    console.log(params.get('vnp_TmnCode')) //required
    console.log(params.get('vnp_TransactionNo')) //required
    console.log(params.get('vnp_TransactionStatus')) //required
    console.log(params.get('vnp_TxnRef')) //required
    console.log(params.get('vnp_SecureHash')) //required
    if (!params.get('vnp_Amount') || !params.get('vnp_TmnCode') || !params.get('vnp_BankCode') || !params.get('vnp_OrderInfo') || !params.get('vnp_TransactionNo') || !params.get('vnp_ResponseCode') || !params.get('vnp_TransactionStatus') || !params.get('vnp_TxnRef') || !params.get('vnp_SecureHash')) {
      navigate('/cart')
    } else {
      updateOrderPayment(location.search, cookie["access_token"])
      setPaymentStatus({
        amount: params.get('vnp_Amount'),
        bankCode: params.get('vnp_BankCode'),
        bankTranNo: params.get('vnp_BankTranNo'),
        cardType: params.get('vnp_CardType'),
        orderInfo: params.get('vnp_OrderInfo'),
        payDate: params.get('vnp_PayDate'),
        responseCode: params.get('vnp_ResponseCode'),
        tmnCode: params.get('vnp_TmnCode'),
        transactionNo: params.get('vnp_TransactionNo'),
        transactionStatus: params.get('vnp_TransactionStatus'),
        bhiveTransactionNo: params.get('vnp_TxnRef'),
        secureHash: params.get('vnp_SecureHash'),
      })
    }
  }, [])

  return (
    <div className={styles.background}>
      <HomePageHeader />
      <h1 className={styles.cart}>Trang thanh toán</h1>
      <div className='container bg-white'>
        <div className='d-flex align-items-start p-3 border-bottom'>
          <div className="d-md-flex align-items-center">
            <p className={styles.shippingText}>
              <span><ImageWithFallback loading="lazy" src={place_marker} alt="Place marker icon" className="ms-1" /></span>Địa chỉ nhận hàng
            </p>
          </div>
        </div>


      </div>
      <HomePageFooter />
    </div>
  );
};

export default PaymentPage;
